import { zRequiredMessage } from '@/form/zod.utils';
import z from 'zod';

const bucketPattern =
  /^(?!\d+\.\d+\.\d+\.\d+$)(?!-)(?!.*--)(?!.*(xn--|sthree-|amzn-s3-demo-))(?!.*(-s3alias|--ol-s3|\.mrap|--x-s3|--table-s3)$)[a-z0-9]([a-z0-9\-.]{1,61}[a-z0-9])?$/;
export const createAllowedBucketsSchema = z.object({
  analysisBatchAllowedBucket: z
    .string()
    .min(1, zRequiredMessage)
    .regex(bucketPattern, {
      message: 'Invalid pattern. Please follow the tooltip icon for details.',
    }),
});
